import { Suspense, lazy } from 'react';
import type { Screen } from '@screens';
import type { ShellMode } from './types';

const BoardView = lazy(() => import('./dc/BoardView'));

interface ScreenPageProps {
  screen: Screen;
  mode?: ShellMode;
  /** Station mode passes its own board -> path mapping so links stay inside the station. */
  resolveBoard?: (board: string) => string | null;
}

/**
 * A canvas screen without a working page: the artboard rendered 1:1 from design/canvas (its own
 * markup, CSS and in-canvas logic) under the persistent "design preview, sample data" bar.
 * Screens with a working page elsewhere link to it from that bar.
 */
export default function ScreenPage({ screen, mode = 'web', resolveBoard }: ScreenPageProps) {
  const working = screen.wiredWeb ? screen.wiredWeb.replace(/\/:[^/]+/g, '') || '/' : null;
  return (
    <Suspense
      fallback={
        <div className="cv" data-mode={mode} style={{ padding: 28 }} aria-busy="true">
          Loading design…
        </div>
      }
    >
      <BoardView key={screen.board} board={screen.board} mode={mode} workingPath={working} resolveBoard={resolveBoard} />
    </Suspense>
  );
}
